import ar from '@twemoji/svg/1f1e6-1f1ea.svg';
import cs from '@twemoji/svg/1f1e8-1f1ff.svg';
import da from '@twemoji/svg/1f1e9-1f1f0.svg';
import de from '@twemoji/svg/1f1e9-1f1ea.svg';
import en from '@twemoji/svg/1f1fa-1f1f8.svg';
import americas from '@twemoji/svg/1f30e.svg';
import es from '@twemoji/svg/1f1ea-1f1f8.svg';
import et from '@twemoji/svg/1f1ea-1f1ea.svg';
import fi from '@twemoji/svg/1f1eb-1f1ee.svg';
import fr from '@twemoji/svg/1f1eb-1f1f7.svg';
import it from '@twemoji/svg/1f1ee-1f1f9.svg';
import ja from '@twemoji/svg/1f1ef-1f1f5.svg';
import ko from '@twemoji/svg/1f1f0-1f1f7.svg';
import nb from '@twemoji/svg/1f1f3-1f1f4.svg';
import nl from '@twemoji/svg/1f1f3-1f1f1.svg';
import pl from '@twemoji/svg/1f1f5-1f1f1.svg';
import br from '@twemoji/svg/1f1e7-1f1f7.svg';
import ru from '@twemoji/svg/1f1f7-1f1fa.svg';
import uk from '@twemoji/svg/1f1fa-1f1e6.svg';
import vi from '@twemoji/svg/1f1fb-1f1f3.svg';
import cn from '@twemoji/svg/1f1e8-1f1f3.svg';
import th from '@twemoji/svg/1f1f9-1f1ed.svg';
import sv from '@twemoji/svg/1f1f8-1f1ea.svg';
import bubble from '@twemoji/svg/1f9cb.svg';
import plead from '@twemoji/svg/1f97a.svg';

export const langs = [
  {
    emoji: ar,
    name: 'عربى',
    key: 'ar',
  },
  {
    emoji: cs,
    name: 'Čeština',
    key: 'cs',
  },
  {
    emoji: da,
    name: 'Dansk',
    key: 'da',
  },
  {
    emoji: de,
    name: 'Deutsch',
    key: 'de',
  },
  {
    emoji: en,
    name: 'English',
    key: 'en',
  },
  {
    emoji: americas,
    name: 'Español Latinoamericano',
    key: 'es-419',
  },
  {
    emoji: es,
    name: 'Español España',
    key: 'es-ES',
  },
  {
    emoji: et,
    name: 'Eesti',
    key: 'et',
  },
  {
    emoji: fi,
    name: 'Suomi',
    key: 'fi',
  },
  {
    emoji: fr,
    name: 'Français',
    key: 'fr',
  },
  {
    emoji: it,
    name: 'Italiano',
    key: 'it',
  },
  {
    emoji: ja,
    name: '日本語',
    key: 'ja',
  },
  {
    emoji: ko,
    name: '한국어',
    key: 'ko',
  },
  {
    emoji: nb,
    name: 'Norsk bokmål',
    key: 'nb-NO',
  },
  {
    emoji: nl,
    name: 'Nederlands',
    key: 'nl',
  },
  {
    emoji: pl,
    name: 'Polski',
    key: 'pl',
  },
  {
    emoji: br,
    name: 'Português Brasileiro',
    key: 'pt-BR',
  },
  {
    emoji: ru,
    name: 'Русский',
    key: 'ru',
  },
  {
    emoji: sv,
    name: 'Svenska (Sverige)',
    key: 'sv-SE',
  },
  {
    emoji: uk,
    name: 'Українська',
    key: 'uk',
  },
  {
    emoji: th,
    name: 'ไทย',
    key: 'th',
  },
  {
    emoji: vi,
    name: 'Tiếng Việt',
    key: 'vi',
  },
  {
    emoji: cn,
    name: '简体中文',
    key: 'zh-Hans',
  },
  {
    emoji: bubble,
    name: '繁體中文',
    key: 'zh-Hant',
  },
  {
    emoji: plead,
    name: 'Engwish~ OwO',
    key: 'en-x-owo',
  },
];
